import { render, staticRenderFns } from "./InventorySummary.vue?vue&type=template&id=ec52d478&scoped=true"
import script from "./InventorySummary.vue?vue&type=script&lang=js"
export * from "./InventorySummary.vue?vue&type=script&lang=js"
import style0 from "./InventorySummary.vue?vue&type=style&index=0&id=ec52d478&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec52d478",
  null
  
)

export default component.exports